/*
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-08-06 09:32:20
 * @LastEditors: knx-xc
 */
import http from '../http';
/**
 * @description:  文章管理列表
 * @params ：  
 */

export var article_list = function article_list() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/article/list',
    data: data,
    formData: true
  };
  return http(params);
};
/**
 * @description:  文章管理列表- 置顶
 * @params ：   id isTop
 */

export var article_top = function article_top() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/article/top',
    data: data,
    formData: true
  };
  return http(params);
};
/**
 * @description:  文章管理列表- 删除
 * @params ：   ids []
 */

export var article_delete = function article_delete() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  console.log(data);
  var params = {
    method: 'post',
    api: '/manage/article/delete',
    data: data
  };
  return http(params);
};
/**
 * @description:  文章管理列表- 保存
 * @params ：   article 
 */

export var article_save = function article_save() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/article/save',
    data: data
  };
  return http(params);
};
/**
 * @description:  文章管理列表- 修改
 * @params ：   article 
 */

export var article_update = function article_update() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/article/update',
    data: data,
    formData: false
  };
  return http(params);
};
/**
 * @description:  文章管理列表- 文章查询
 * @params ：   info 
 */

export var article_info = function article_info() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/manage/article/info/' + data['id'],
    data: data
  };
  return http(params);
};